import { deserialise } from './serialise.js';

const getMeasures = (subscriptions) => (
  // https://developer.mozilla.org/en-US/docs/Web/API/Performance/getEntriesByType#browser_compatibility
  "getEntriesByType" in window.performance ? window.performance.getEntriesByType("measure").flatMap(({ entryType, name, duration, startTime }) => {
    const detail = deserialise(name);
    return entryType === "measure" && detail && subscriptions.includes(detail.subscription) ? {
      name,
      detail,
      duration,
      entryType,
      startTime,
      toJson: () => JSON.stringify(void 0)
    } : [];
  }) : []
);

export { getMeasures };
